/**
 * Created by lihanying on 2017/6/29.
 */
import { GETCLUBBLACKLIST } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBBLACKLIST:
      return Object.assign({}, state, { clubBlacklist: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubBlacklist/reduce.js